module.exports = {
  pageSettings: {
    'pageName': 'Praxis Mandt',
    'footerLine': 'COPYRIGHT 2019 | NICOLAS MANDT | BEETHOVENSTRASSE 10, 50674 KÖLN',
    'contact1': 'Nicolas Mandt',
    'contact2': 'Dipl. Päd., Kinder- und Jugendlichenpsychotherapeut',
    'contact3': 'Beethovenstraße 10, 50674 Köln',
    'contact4': '0176 - 44 40 14 24',
    'contact5': 'mail@praxismandt.de',
    'headerTitle': 'Herzlich Willkommen auf den Seiten der Praxis Nicolas Mandt',
    'headerSubtitle': 'tiefenpsychologisch fundierte Psychotherapie für Kinder, Jugendliche und junge Erwachsene',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    'logo': {'path': '/cockpit/storage/uploads/2019/03/01/5c78e4a0de37alogo.png'}
  },
  mainMenu: [{
    'name': '',
    'link': '/#home',
    'anchor': 'home',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 0,
    '_modified': 1551441599,
    '_created': 1551425236,
    '_id': '5c78ded464356308380001b8',
    'nameBold': null,
    '_pid': null,
    'component': 'ParallaxImage',
    'collection': 'contentStartseite',
    'visible': true,
    'menuText': 'Startseite',
    'children': []
  }, {
    'name': 'Das',
    'nameBold': 'Behandlungsangebot',
    'link': '/#services',
    'anchor': 'services',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 1,
    '_modified': 1551895023,
    '_created': 1551425465,
    '_id': '5c78dfb96435630838000225',
    '_pid': null,
    'component': 'CardSpace',
    'collection': 'contentLeistung',
    'visible': true,
    'menuText': 'Behandlungsangebot',
    'children': []
  }, {
    'menuText': 'Zu meiner Person',
    'name': 'Zu meiner',
    'nameBold': 'Person',
    'link': '/#aboutme',
    'anchor': 'aboutme',
    'component': 'TextAndImage',
    'collection': 'contentAboutMe',
    'visible': true,
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 2,
    '_modified': 1551898812,
    '_created': 1551898779,
    '_id': '5c80189b6435632d34000071',
    '_pid': null,
    'children': []
  }, {
    'name': 'Die',
    'link': '/#office',
    'anchor': 'office',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 3,
    '_modified': 1552525228,
    '_created': 1551425267,
    '_id': '5c78def36435630838000127',
    'nameBold': 'Praxis',
    '_pid': null,
    'component': 'Gallery',
    'collection': 'contentPraxis',
    'visible': true,
    'menuText': 'Die Praxis',
    'children': []
  }, {
    'name': 'Die',
    'nameBold': 'Kontaktaufnahme',
    'link': '/#contact',
    'anchor': 'contact',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 4,
    '_modified': 1551441629,
    '_created': 1551425515,
    '_id': '5c78dfeb64356308380003ad',
    '_pid': null,
    'component': 'Contact',
    'collection': 'contentKontakt',
    'visible': true,
    'menuText': 'Kontakt',
    'children': []
  }, {
    'name': 'Die',
    'nameBold': 'Anfahrt',
    'link': '/#map',
    'anchor': 'map',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 5,
    '_modified': 1551441620,
    '_created': 1551425492,
    '_id': '5c78dfd464356308380000fb',
    '_pid': null,
    'component': 'Map',
    'collection': 'contentMap',
    'visible': true,
    'menuText': 'Anfahrt',
    'children': []
  }],
  subMenu: [{
    'name': 'Häufig gestellte',
    'nameBold': 'Fragen',
    'link': '/faq',
    'anchor': '#faq',
    'page': 'Faq',
    'collection': 'contentFaq',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 0,
    '_modified': 1552525286,
    '_created': 1551426253,
    '_id': '5c78e2cd64356308380003d3',
    'visible': true,
    'menuText': 'FAQs',
    'children': []
  }, {
    'name': '',
    'nameBold': 'Artikel',
    'link': '/blog',
    'anchor': '#blog',
    'page': 'Blog',
    'collection': 'contentBlog',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 1,
    '_modified': 1551440542,
    '_created': 1551426286,
    '_id': '5c78e2ee6435630838000300',
    'menuText': 'Artikel',
    'visible': null,
    'children': []
  }, {
    'name': '',
    'nameBold': 'Impressum',
    'link': '/imprint',
    'anchor': '#imprint',
    'page': 'Imprint',
    'collection': 'contentImprint',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 2,
    '_modified': 1551440556,
    '_created': 1551426319,
    '_id': '5c78e30f6435630838000051',
    'visible': true,
    'menuText': 'Impressum',
    'children': []
  }, {
    'name': '',
    'nameBold': 'Datenschutz',
    'link': '/gdpr',
    'anchor': '#gdpr',
    'page': 'Gdpr',
    'collection': 'contentGdpr',
    '_mby': '5c78dbb16435630838000192',
    '_by': '5c78dbb16435630838000192',
    '_o': 3,
    '_modified': 1551440569,
    '_created': 1551426358,
    '_id': '5c78e3366435630838000104',
    'visible': true,
    'menuText': 'Datenschutz',
    'children': []
  }]
}



//////////////////
// WEBPACK FOOTER
// ./config/testdaten.js
// module id = QwuK
// module chunks = 1